export const HeroData = [
    {
        title: '',
        path: '/',
        label: 'View Home',
        image: './assets/logo__edit.png',
        alt: 'darkalogo'
    }
]